/* import __COLOCATED_TEMPLATE__ from './event-move-intermediate-record-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class EventMoveIntermediateRecordComponent extends Component 
{
	@service store;
	@service ajax;
	
	@tracked destinationTimingPoint = null;
	@tracked recordID = null;
	
	@action
	async destinationTimingPointChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.destinationTimingPoint = null;
		}
		else
		{
			const timingPoint = await this.store.findRecord('IntermediateTimingPoint', browserEvent.target.value);
			this.destinationTimingPoint = timingPoint;
		}
	}
	
	@action
	async moveRecord()
	{	
		if(this.recordID != null)
		{
			const intermediateTimingRecord = await this.store.findRecord('IntermediateTimingRecord', this.recordID);
			
			intermediateTimingRecord.IntermediateTimingPointId = this.destinationTimingPoint;
			
			try
			{
				await intermediateTimingRecord.save();
			}
			catch (error)
			{
				alert(error);
				intermediateTimingRecord.rollbackAttributes();
			}
			
			this.recordID = null;
		}
	}
}